import { render, staticRenderFns } from "./role-manager.vue?vue&type=template&id=65275847&scoped=true&"
import script from "./role-manager.vue?vue&type=script&lang=js&"
export * from "./role-manager.vue?vue&type=script&lang=js&"
import style0 from "./role-manager.vue?vue&type=style&index=0&id=65275847&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65275847",
  null
  
)

export default component.exports